export default "__VITE_ASSET__0ILp0dxx__"